<template>
    <section class="gmp-section gmp-mb-xl">
        <div class="gmp-section-header ">
            <div class="h-c-page">
                <div class="h-c-grid">
                    <div class="h-c-grid__col">
                        <h3 class="h-c-headline h-c-headline--one gmp-section-header--center">
                            高效的私域运营工具
                        </h3>
                    </div>
                </div>
            </div>
        </div>

        <div class="h-c-page">
            <div class="product-tout product-tout--narrow">
                <div class="product-tout__content">

                    <div class="product-tout__icon">
                        <picture>
                            <img src="@/assets/img/4a.png" alt="" class="">
                        </picture>
                    </div>
                    <div class="product-tout__copy">
                        <h4 class="h-c-headline product-tout__headline">
                            下单和拼单小程序
                        </h4>
                        <p class="h-c-headline h-c-headline--four">
                            选择到店自提或拼单自提的方式，提供了更灵活的购物体验。特别适合那些时间紧张、不愿意排队的顾客。
                        </p>
                    </div>
                    <div class="product-tout__link">
                        <a @click="toPickup('/member/selfPickUp','下单和自提')" class="h-c-link h-c-link--internal gmp-link">
                            查看详细
                        </a>
                    </div>
                </div>

                <div class="product-tout__image">
                    <img src="@/assets/img/lili2.png" alt="" class="gmp-no-grab ">
                </div>
            </div>
        </div>

        <div class="product-card-grid">
            <div class="h-c-page">
                <div class="glue-pagination h-c-carousel h-c-carousel--tile h-c-carousel--tile-small-only h-u-mt-std ng-isolate-scope glue-o-pagination">
                    <div class="h-c-carousel__wrap product-card-grid__wrap--narrow ng-scope">
                        <ul class="abc " >
                            <li class="h-c-carousel__item product-card product-card--hide-for-large">
                                <a @click="toPickup('/member/selfPickUp','下单和自提')"  class="h-c-tile h-c-tile--border h-c-tile--hoverable h-c-tile--small-height">
                                    <div class="h-c-tile__header h-c-tile__header--icon product-card__header">
                                        <picture>
                                            <img src="@/assets/img/a-bianzu6.png" alt=""
                                                 class="gmp-product-icon gmp-product-icon--fixed">
                                        </picture>
                                    </div>

                                    <div class="h-c-tile__body">
                                        <h4 class="h-c-tile__headline product-card__headline">
                                            下单和拼单小程序
                                        </h4>
                                        <p class="h-c-tile__description">
                                            选择到店自提或拼单自提的方式，提供了更灵活的购物体验。特别适合那些时间紧张、不愿意排队的顾客。
                                        </p>

                                        <ul class="h-c-tile__links">
                                            <li class="h-c-tile__link">
                                                <img src="@/assets/img/arrow-right.png" alt=""
                                                     class="h-c-tile__link h-c-tile__link--arrow">
                                            </li>
                                        </ul>
                                    </div>

                                </a>
                            </li>

                            <div style="clear:both;"></div>
                        </ul>

                    </div>


                </div>


            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "MemberProduct",
        props:['clientWidth'],
        data() {
            return {
                activeIndex: 0,
            }
        },
        mounted() {


        },

        watch: {
            clientWidth: function (val) {
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                this.clientWidth = val
                this.changeFixed(this.clientWidth)
            },


        },
        methods: {
            showIndex(data) {
                var itemWidth = this.$('.h-c-carousel__item').width();
                var moveWidth = "";

                moveWidth = - + data  * itemWidth ;
                moveWidth = Number(moveWidth) + Number(40 );
                if(data === 0){
                    moveWidth = 39
                }

                this.$('#proUl').css({
                    "transform": "translate3d(" + moveWidth + "px, 0px, 0px)",
                    "transition": "transform .4s"
                })

                this.activeIndex = data;
            },

            changeFixed(data) {
                console.log("changefiexe" + data)
                if (data < 601) {
                    var how = this.$('.h-c-carousel__item').width() * 8 + 160;
                    console.log("xiaoyu 600");

                    this.$('#proUl').css({
                        'width': how + 'px',
                        "transform": "translate3d(139px, 0px,0px)",
                        "transition": "transform .4s, background .4s"
                    })
                }else{
                    console.log(">>>>>> 600");

                    this.$('#proUl').css({
                        'width': "auto",
                        "transform": "translate3d(0px, 0px,0px)",
                        "transition": "transform .4s, background .4s"
                    })

                }
            },


            toPickup(data, hanzi) {
                this.$router.push(data)
                this.isShowDrawer = false;
                this.$('body').removeClass('h-is-showing-drawer');

                this.$('.h-c-header__drawer-nav-list').remove()
                this.$('.h-c-header').addClass('h-c-header--product-initiative').removeClass('h-c-header--product-marketing-one-tier');

                var hasAdd = this.$('.h-c-header__initiative-logo');
                if (hasAdd.length === 0) {
                    var data1 = `<div class="h-c-header__initiative-logo">
                                    <a   class="h-c-header__initiative-logo-link">
                                        <span class="h-c-header__initiative-logo-text">` + hanzi + `</span>
                                    </a>
                                 </div>`
                    this.$('.h-c-header__bar').append(data1);

                    var data2 = `<div class="h-c-header__drawer-initiative-logo">
                                     <div class="h-c-header__drawer-initiative-logo-link">
                                        <span class="h-c-header__drawer-initiative-logo-text">` + hanzi + `</span>
                                     </div>
                                 </div>`;
                    this.$('.h-c-header__drawer-bar').append(data2)
                }


                var data3 = `<ul class="h-c-header__drawer-nav-list">
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link h-is-active " to-where="` + data + `">概览</a>
                                </li>
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link "  to-where="` + data + `/PICK_Benefit">好处</a>
                                </li>
                                <li class="h-c-header__drawer-nav-li">
                                    <a  class="h-c-header__drawer-nav-li-link"  to-where="` + data + `/PICK_Special">特点</a>
                                </li>
                              </ul>`;
                this.$('.h-c-header__drawer-nav').append(data3)


                let that = this;
                var x = document.querySelectorAll('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < x.length; i++) {
                    x[i].addEventListener('click', function () {
                        that.toEnterprisePage(this.getAttribute('to-where'))
                    })
                }
            },

            toEnterprisePage(data){
                this.$router.push(data)
                this.$('body').removeClass('h-is-showing-drawer');
                var lis = this.$('.h-c-header__drawer-nav-li-link');
                for(var i = 0;i < lis.length; i ++){
                    var toWhere = this.$(lis[i]).attr('to-where');
                    console.log("toWhere===" + toWhere);
                    if(toWhere === data){
                        this.$(lis[i]).addClass('h-is-active');
                    }else {
                        this.$(lis[i]).removeClass('h-is-active')
                    }
                }
            },



        }
    }
</script>

<style lang="less">

.abc{
    position: relative;
}

    /*.aaa{*/
    /*    float: left;*/
    /*}*/


</style>